import { StremioStream } from "../../../../apis/towers-sports-api/types";

import { useSelector } from "react-redux";
import users from "../../../users";
import { cn } from "../../../../utils/utils";
import { parseTextToHtml } from "../utils";

import './ChannelStreamCard.css';
import ButtonV2 from "../../../shared/button-v2/button-v2";
import React from "react";

export const ChannelStreamCard = ({ stream, onClick, activeViewers }: {
    stream: StremioStream,
    onClick?: (stream: StremioStream) => void,
    activeViewers?: number
}) => {
    const darkTheme = useSelector(users.selectors.isDarkMode);

    return (
        <div className={cn("channel-stream-card", { 'channel-stream-card--dark': darkTheme })}>
            <div className="channel-stream-card__info">
                <div style={{
                    width: "90px",
                }} dangerouslySetInnerHTML={{ __html: parseTextToHtml(stream.name) }}></div>
                <div style={{
                    flex: 1,
                }} dangerouslySetInnerHTML={{ __html: parseTextToHtml(stream.description) }}></div>
            </div>
            <div className="channel-stream-card__footer">
                <div className="channel-stream-card__actions">
                    <ButtonV2 size="small" width={40} title="Reproducir" onClick={() => {
                        onClick?.(stream);
                    }}><i className="fa-solid fa-play"></i>
                    </ButtonV2>
                    <ButtonV2 size="small" title="Abrir en Acestream" width={40} onClick={() => {
                        window.open(`acestream://${stream.hash}`);
                    }}><img height={25} alt="Ace Stream"
                        src="https://dashboard.snapcraft.io/site_media/appmedia/2017/02/icon_14.png" />
                    </ButtonV2>
                </div>
                {activeViewers !== undefined && <div className="channel-stream-card__viewers" style={{
                    opacity: activeViewers > 0 ? 1 : 0.5,
                }}>
                    <i className="fa-solid fa-eye"></i> {activeViewers}
                </div>}
            </div>
        </div>
    );
}
